import { render } from "./aws-login.vue?vue&type=template&id=2b245cd0&scoped=true"
import script from "./aws-login.vue?vue&type=script&lang=js"
export * from "./aws-login.vue?vue&type=script&lang=js"

import "./aws-login.vue?vue&type=style&index=0&id=2b245cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b245cd0"]])

export default __exports__